import React from 'react';
import PropTypes from 'prop-types';
import LoginFormHeader from '../../Components/LoginFormHeader';
import RegisterFormContent from './RegisterFormContent';

import './RegisterForm.scss';
import '../../Components/LoginForm.scss';

function RegisterForm(props) {
  const { isShibboleth, ipAddress, isAnonymousUser, cancel } = props;

  const headerActionMessage = isShibboleth ? 'Activate Personalization' : 'Register';
  const headerInfoMessage = isShibboleth ? (
    <span>
      <b>Profile personalization is required for your account and you must complete the information below </b>
      by registering your details on Reaxys you can log in and customize the user interface,
      <strong> Create Alerts</strong> and <strong>Save Searches</strong>. This will also give you a longer session timeout (6 hours compared
      to 30 minutes).
    </span>
  ) : (
    <span>
      by registering your details on Reaxys you can log in and customize the user interface,
      <strong> Create Alerts</strong> and <strong>Save Searches</strong>. This will also give you a longer session timeout (6 hours compared
      to 30 minutes).
    </span>
  );
  return (
    <div className="login-form login-page-form-wrapper register-form">
      <LoginFormHeader
        ipAddress={ipAddress}
        isAnonymousUser={isAnonymousUser}
        cancel={cancel}
        actionMessage={headerActionMessage}
        infoMessage={headerInfoMessage}
      />
      <RegisterFormContent {...props} />
    </div>
  );
}

RegisterForm.propTypes = {
  isShibboleth: PropTypes.bool,
  isAnonymousUser: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  ipAddress: PropTypes.string,
};

export default RegisterForm;
